import { action, Action, Thunk, thunk } from 'easy-peasy';
import { Configuration } from '../api/types';
import { StoreModel } from './types';
import { configurationApi } from '../api';

export const defaultConfiguration: Configuration = {
  pricingVersion: '',
  discountVp: 0,
  discountVpCalculation: false,
};

export interface ConfigurationStore {
  isLoading: boolean;
  detail: Configuration;
  setDetail: Action<ConfigurationStore, Configuration>;
  setLoading: Action<ConfigurationStore, boolean>;
  fetchConfiguration: Thunk<ConfigurationStore, void, any, StoreModel>;
  updateConfiguration: Thunk<
    ConfigurationStore,
    Configuration,
    any,
    StoreModel,
    Promise<boolean>
  >;
}

const configuration: ConfigurationStore = {
  isLoading: false,
  detail: defaultConfiguration,
  setDetail: action((state, payload) => {
    state.detail = payload;
  }),
  setLoading: action((state, payload) => {
    state.isLoading = payload;
  }),
  fetchConfiguration: thunk(async actions => {
    try {
      actions.setLoading(true);
      const { data } = await configurationApi.getCurrentConfiguration();
      actions.setDetail(data);
      actions.setLoading(false);
    } catch (error) {
      actions.setLoading(false);
    }
  }),
  updateConfiguration: thunk(async (actions, payload) => {
    try {
      actions.setLoading(true);
      const { data } = await configurationApi.updateConfiguration(payload);
      actions.setDetail(data);
      actions.setLoading(false);
    } catch (error) {
      actions.setLoading(false);
      return false;
    }
    return true;
  }),
};

export default configuration;
